module.exports = __webpack_public_path__ + "img/arrow-right.dcd9da1b.svg";